import React, { useEffect, useState } from 'react';

import { getActiveReactPage } from '../../../../r/shared/utils';
import Button from '../../../../r/components/shared/button';
import { files } from '../../../../r/libs/assets';
import useClassName from 'r/hooks/class-name';
import { TipsWrapper } from './styled';

const signUp = [
  {
    image: 'https://storage.googleapis.com/fplsblog/new-auth/create_account_1_heavy_lifting.svg',
    title: 'Let your forms do the heavy lifting',
    info: 'Recieve files, payments, digital signatures, orders and so much more with functional forms that just work.'
  },
  {
    image: 'https://storage.googleapis.com/fplsblog/new-auth/create_account_2_data.svg',
    title: 'Join the thousands of users getting unmatched data through dynamic forms, surveys and quizzes'
  },
  {
    image: 'https://storage.googleapis.com/fplsblog/new-auth/create_account_1_heavy_lifting.svg',
    title: 'Let your forms do the heavy lifting',
    info: 'Recieve files, payments, digital signatures, orders and so much more with functional forms that just work.'
  },
  {
    image: 'https://storage.googleapis.com/fplsblog/new-auth/create_account_2_data.svg',
    title: 'Join the thousands of users getting unmatched data through dynamic forms, surveys and quizzes'
  }
];

const signIn = [
  {
    image: 'https://storage.googleapis.com/fplsblog/new-auth/Login_1_team.svg',
    title: 'Work even better with your team',
    list: ['Collaborate on functional form design', 'Manage respondents and form data', 'Create the perfect report for your next presentation']
  },
  {
    image: 'https://storage.googleapis.com/fplsblog/new-auth/login_2_payment.svg',
    title: 'Formplus has processed over $1M with secure payment forms',
    list: ['Receive payments from anywhere in the world directly on your form', 'Drag and drop the Formplus Paypal, Paystack, or Stripe Payment fields to begin', 'Multiple currencies and diverse locations supported']
  },
  {
    image: 'https://storage.googleapis.com/fplsblog/new-auth/login_3_smart_forms.svg',
    title: 'Stay one step ahead with smart forms',
    list: ['Offer more tailored surveys with conditional logic', ' Automatically sort out calculations for quizzes and orders based on respondents’ inputs', 'Collect responses offline from respondents in poor connection areas']
  }
];

const pageTips = {
  'ResetPassword': signIn,
  'Confirm2FA': signUp,
  'SignIn': signIn,
  'SignUp': signUp
};

const Tips = () => {
  const [activeTipIndex, setActiveTipIndex] = useState(0);
  const page = getActiveReactPage();
  const tips = pageTips[page.name];

  const scrollTips = () => setActiveTipIndex((prevIndex) => (
    prevIndex + 1 < tips.length ? prevIndex + 1 : 0
  ));
  
  useEffect(() => {
    const interval = setInterval(() => {
      scrollTips();
    }, 10000);

    return () => clearInterval(interval);
  }, [tips]);

  useEffect(() => {
    setActiveTipIndex(0);
  }, [page]);

  if (!tips) return null;

  return (
    <TipsWrapper>
      <div className="container">
        {tips.map((tip, index) => {
          const isLastTip = index === (activeTipIndex - 1 + tips.length) % tips.length;
          const isNextTip = index === (activeTipIndex + 1) % tips.length;
          const isActiveTip = index === activeTipIndex;
          const { image, title, list, info } = tip;

          const className = useClassName([
            isActiveTip ? 'active' : '',
            isNextTip ? 'next' : '',
            isLastTip ? 'last' : '',
            'tip'
          ]);

          return (
            <div key={index} className={className}>
              <div className="image">
                <img src={image} alt={title} />
              </div>
              
              <div className="info">
                <h4>{title}</h4>
                {info && <p>{info}</p>}

                {list && (
                  <ul>
                    {list.map((item, i) => (
                      <li key={item}>
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )
        })}
      </div>
      
      <p className="indicators">
        {tips.map((_, index) => (
          <span
            className={`indicator ${activeTipIndex === index ? 'active' : ''}`}
            key={index}
          />
        ))}
      </p>

      <div className="navigation">
        <Button
          icon={files.arrowRight}
          onClick={scrollTips}
          iconPosition="end"
          variant="link"
          size="small"
          text="Next"
          transparent
          borderless
        />
      </div>
    </TipsWrapper>
  );
};

export default Tips;